// extracted by mini-css-extract-plugin
module.exports = {"deeplinkForm":"ProductDeeplinkForm_deeplinkForm__1RsIY","titleItem":"ProductDeeplinkForm_titleItem__1i1xS","commentItem":"ProductDeeplinkForm_commentItem__3jK4o"};